import { ClaimScoreApiServiceError } from 'services/ClaimscoreApiService/client';

export function getErrorMessage(error: unknown): string {
  if (
    typeof error === 'object' &&
    error !== null &&
    'response' in error &&
    (error as ClaimScoreApiServiceError).response?.data?.errors?.[0]?.message
  ) {
    return (error as ClaimScoreApiServiceError).response.data.errors[0].message;
  }

  return 'Oops! Something went wrong. Try again please!';
}
